import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const TransitionSpacer = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const lineWidth = useTransform(scrollYProgress, [0.1, 0.5], ["0%", "100%"]);
  const textOpacity = useTransform(scrollYProgress, [0.15, 0.4, 0.7, 0.9], [0, 1, 1, 0]);
  const textY = useTransform(scrollYProgress, [0.15, 0.4], [40, 0]);
  const glowOpacity = useTransform(scrollYProgress, [0.2, 0.5, 0.8], [0, 0.6, 0]);

  return (
    <section
      ref={ref}
      className="relative py-40 md:py-56 overflow-hidden"
      data-testid="transition-spacer"
      aria-hidden="true"
    >
      {/* Central glow pulse */}
      <motion.div
        style={{ opacity: glowOpacity }}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full pointer-events-none"
      >
        <div className="w-full h-full rounded-full bg-purple-600/10 blur-[120px]" />
      </motion.div>

      {/* Animated horizontal line */}
      <div className="absolute top-1/2 left-0 right-0 -translate-y-1/2 flex items-center justify-center">
        <motion.div
          style={{ width: lineWidth }}
          className="h-px bg-gradient-to-r from-transparent via-purple-500/40 to-transparent"
        />
      </div>

      {/* Center diamond accent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
        <motion.div
          style={{ opacity: textOpacity }}
          className="w-3 h-3 rotate-45 border border-purple-500/40 bg-purple-500/10 backdrop-blur-sm"
        />
      </div>

      {/* Statement text */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <motion.div style={{ opacity: textOpacity, y: textY }}>
          <span className="text-[11px] text-purple-400/40 font-space tracking-[0.3em] uppercase block mb-8">
            Trabajo Selecto
          </span>
          <h2 className="font-space font-bold text-3xl sm:text-4xl md:text-6xl lg:text-7xl text-white/90 leading-[1.05] tracking-tight">
            Donde la estrategia
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400/80 via-violet-300/70 to-purple-500/80">
              se materializa
            </span>
          </h2>
          <p className="mt-6 text-sm md:text-base text-white/25 max-w-md mx-auto leading-relaxed">
            Cada proyecto es una operación de precisión diseñada para generar impacto medible.
          </p>
        </motion.div>
      </div>

      {/* Subtle side lines */}
      <motion.div
        style={{ opacity: glowOpacity }}
        className="absolute top-1/2 left-8 md:left-16 -translate-y-1/2 w-px h-24 bg-gradient-to-b from-transparent via-purple-500/20 to-transparent"
      />
      <motion.div
        style={{ opacity: glowOpacity }}
        className="absolute top-1/2 right-8 md:right-16 -translate-y-1/2 w-px h-24 bg-gradient-to-b from-transparent via-purple-500/20 to-transparent"
      />
    </section>
  );
};
